export default "__VITE_ASSET__c9fa6365__"